import { useState } from 'react';
import css from './Login.module.css';
import * as authServices from '../../../services/authServices';

function Login({ onAuthSuccess }) {
    const [mode, setMode] = useState('signin');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (mode === 'register' && password !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }

        setLoading(true);
        try {
            const action = mode === 'register' ? authServices.register : authServices.login;
            const result = await action(email, password);
            authServices.saveToken(result.token);
            onAuthSuccess(result.user);
        } catch (err) {
            setError(err.message || 'Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={css.container}>
            <form onSubmit={handleSubmit} className={css.form}>
                <div className={css.logo}>
                    <img src="logo-white.png" alt="Plane Care Academy" />
                </div>
                <div className={css.welcomeMessage}>
                    <h2>Welcome</h2>
                    <p>{mode === 'signin' ? 'Sign in to continue' : 'Create your account'}</p>
                </div>

                <div className={css.tabs}>
                    <button
                        type="button"
                        className={mode === 'signin' ? css.tabActive : css.tab}
                        onClick={() => { setMode('signin'); setError(''); }}
                    >
                        Sign in
                    </button>
                    <button
                        type="button"
                        className={mode === 'register' ? css.tabActive : css.tab}
                        onClick={() => { setMode('register'); setError(''); }}
                    >
                        Register
                    </button>
                </div>

                <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email"
                    className={css.input}
                    required
                    autoComplete="email"
                />
                <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Password"
                    className={css.input}
                    required
                    autoComplete={mode === 'register' ? 'new-password' : 'current-password'}
                />
                {mode === 'register' && (
                    <input
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        placeholder="Confirm password"
                        className={css.input}
                        required
                        autoComplete="new-password"
                    />
                )}
                <button type="submit" className={css.button} disabled={loading}>
                    {loading ? 'Please wait…' : mode === 'signin' ? 'Sign in' : 'Register'}
                </button>
                {error && <p className={css.error}>{error}</p>}
            </form>
        </div>
    );
}

export default Login;
